"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Container = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, content = _a.content, _c = _a.el, ContainerElement = _c === void 0 ? 'div' : _c, fluid = _a.fluid, text = _a.text, _d = _a.textAlign, textAlign = _d === void 0 ? 'left' : _d, props = __rest(_a, ["children", "className", "content", "el", "fluid", "text", "textAlign"]);
    var classes = classnames_1.default('semantic-anvil-theme Container', className, (_b = {
            'Container--fluid': fluid,
            'Container--text': text
        },
        _b["ta-" + textAlign] = textAlign,
        _b));
    return (react_1.default.createElement(ContainerElement, __assign({ className: classes }, props), react_1.default.Children.count(children) > 0 ? children : content));
};
exports.Container = Container;
//# sourceMappingURL=Container.js.map